import { useEffect, useState } from 'react'
import './Notification.css'

export type NotificationType = 'confirm' | 'cancel' | 'primary' | 'info' | 'audio' | 'success'

export interface NotificationProps {
  message: string
  type?: NotificationType
  position?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left'
  duration?: number
  onClose?: () => void
  autoClose?: boolean
  clickable?: boolean
  onClick?: () => void
}

function Notification({ 
  message, 
  type = 'primary', 
  position = 'bottom-left',
  duration = 2000,
  onClose,
  autoClose = true,
  clickable = false,
  onClick
}: NotificationProps) {
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    if (autoClose && duration > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false)
        setTimeout(() => {
          onClose?.()
        }, 300) // Wait for fade out animation
      }, duration)

      return () => clearTimeout(timer)
    }
    // If autoClose is false, do nothing - notification stays visible
  }, [autoClose, duration, onClose])

  if (!isVisible) {
    return null
  }

  return (
    <div 
      className={`notification notification-${type} notification-${position} ${autoClose ? 'notification-auto-close' : 'notification-persistent'} ${clickable ? 'notification-clickable' : ''}`}
      onClick={clickable ? onClick : undefined}
      style={{ cursor: clickable ? 'pointer' : 'default' }}
    >
      <span className={type === 'audio' ? 'notification-audio-content' : ''}>{message}</span>
    </div>
  )
}

export default Notification
